import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Lines, FadeUp } from "../site/Reveal";
import { SectionLabel } from "../site/Btn";
import { useLang } from "../../i18n/lang";
import { useSiteImages } from "../../lib/siteImages";

export const Manifesto = () => {
  const { t } = useLang();
  const img = useSiteImages();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section ref={ref} className="px-6 sm:px-10 lg:px-14 py-28 sm:py-36 lg:py-48" data-testid="manifesto-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-8">
        <div className="lg:col-span-6 lg:pr-10 flex flex-col">
          <SectionLabel n={1}>{t.manifesto.label}</SectionLabel>
          <Lines lines={[t.manifesto.title]} className="f-serif font-light tracking-[-0.02em] leading-[1] text-5xl sm:text-6xl lg:text-7xl mt-10" />
          <FadeUp className="mt-12 lg:mt-auto lg:pt-24 max-w-lg lg:ml-[16%]" delay={0.2}>
            <p className="text-lg leading-[1.75] text-[#3A3A3A]">{t.manifesto.text}</p>
          </FadeUp>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <FadeUp y={0} className="relative overflow-hidden aspect-[4/5] bg-[#F0F0F0]">
            {img("manifesto") && <motion.img style={{ y, scale: 1.2 }} src={img("manifesto")} loading="lazy"
              alt="Macro detail of natural stone veining" className="absolute inset-0 w-full h-full object-cover" />}
          </FadeUp>
          <p className="mt-4 f-mono text-[0.7rem] tracking-[0.1em] text-[#555555] flex justify-between"><span>{t.manifesto.caption}</span><span>Fig. 01</span></p>
        </div>
      </div>
    </section>
  );
};
